import React from 'react';
import styled from 'styled-components';
import ClickAway from '@material-ui/core/ClickAwayListener';
import ArrowDown from '@material-ui/icons/KeyboardArrowDown';

import { Context } from '../../context';
import Input from '../Input';
import { DefaultButton as Button } from '../Button';

const Wrap = styled.div`
  display: flex;
  position: relative;
  flex: 1;
  max-width: 480px;
  flex-direction: column;
  justify-content: space-between;
`;

const InputWrap = styled.div`
  width: auto;
  position: relative;
  overflow-x: hidden;
`

const Select = styled.div`
  margin: 5px 0;
  position: absolute;
  top: 50px;
  max-height: 400px;
  z-index: 3;
  border-radius: 8px;
  background-color: #4D4D59;
  display: flex;
  flex-direction: column;
  justidy-content: flex-start;
  overflow-x: hidden;
`;

const SelectItem = styled.div`
  width: 100%;
  padding: 12px 16px !important;
  min-height: 37px !important;
  box-sizing: border-box;
  vertical-align: middle;
  display: flex;
  text-align: left;
  cursor: pointer;
  ${p => p.hover && `&:hover { background-color: gray}`};
  ${p => p.child && `padding-left: 24px !important`};
  ${p => p.active && 'background-color: gray'};
`;

const NoFoundSelectItem = styled.div`
  width: 100%;
  padding: 12px 16px;
  display: flex;
  text-align: left;
  cursor: pointer;
`

const SelectItemTypography = styled.p`
  margin: auto 0;
  white-space: pre-wrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const ArrowDownButton = styled.div`
  height: 100%;
  display: flex;
  width: 50px;
  justify-content: center;
  background-color: transparent;
  cursor: pointer;
  &:hover {
    background-color: #b6b5b542;
  }
  position: absolute;
  right: 0;
  top: 0;
  z-index: 2;
  svg {
    margin: auto 0;
  }
`

export default ({ options, input, button, onSelect }) => {
  const { state: { sports } } = React.useContext(Context)

  const [open, openSelect] = React.useState(false);
  const [result, changeResult] = React.useState(options || []);
  const [inputValue, changeInputValue] = React.useState(input.value || '');
  const [active, changeActive] = React.useState(0);

  React.useEffect(() => {
    changeResult(options)
  }, [options]);

  const onChange = ({ target: { value } }) => {
    const results = options.filter(({ title }) => {
      return title.toLowerCase().indexOf(value.toLowerCase()) >= 0;
    });
    changeInputValue(value)
    changeResult(results);
    openSelect(true);
  };

  const onAdd = option => () => {
    const oldKey = Object(sports.find(x => x.title === inputValue)).key;
    onSelect(option, oldKey);
    changeInputValue(option.title);
    openSelect(false);
  }

  const onButtonClick = () => {
    let id = null;
    sports.forEach(x => {
      if (x.title === inputValue) {
        id = x.id;
      }
      x.variants.forEach(n => {
        if (n.title === inputValue) {
          id = n.id;
        }
        return false
      })
      return false;
    })
    button.onClick(id)
  }

  const onKeyDown = ({ keyCode }) => {
    if (keyCode === 40 && active >= 0) {
      changeActive(active + 1)
    }
    if (keyCode === 38 && active >= 0) {
      changeActive(active - 1)
    }
    if (keyCode === 13) {
      onAdd(result.find((x, i) => i === active))()
    }
  }

  return (
    <React.Fragment>
      <ClickAway onClickAway={() => { openSelect(false) }}>
        <Wrap>
          <InputWrap>
            <Input
              {...input}
              value={inputValue}
              onKeyDown={onKeyDown}
              onChange={onChange}
              onClick={() => { openSelect(true) }}
            />
            <ArrowDownButton onClick={() => { openSelect(true) }}>
              <ArrowDown />
            </ArrowDownButton>
          </InputWrap>
          {open && (
            <Select className={input.className}>
              {
                result.length ? result.map((x, i) => (
                  <React.Fragment>
                    <SelectItem
                      key={x.id}
                      hover={false}
                      {...(!x.variants.length ? {
                        onClick: onAdd(x),
                        hover: true,
                        active: i === active
                      } : {})}
                    >
                      <SelectItemTypography>
                        {x.title}
                      </SelectItemTypography>
                    </SelectItem>
                    {x.variants ? x.variants.map(n => (
                      <SelectItem child={true} hover={true} key={n.id} onClick={onAdd(n)}>
                        <SelectItemTypography>
                          {n.title}
                        </SelectItemTypography>
                      </SelectItem>
                    )) : null}
                  </React.Fragment>
                )) : (
                    <NoFoundSelectItem>
                      <SelectItemTypography>
                        Ни чего не найдено
                      </SelectItemTypography>
                    </NoFoundSelectItem>
                  )
              }
            </Select>
          )}
        </Wrap>
      </ClickAway>
      <Button
        onClick={onButtonClick}
        classes={{ root: button.className }}
      >
        {button.label}
      </Button>
    </React.Fragment>
  )
};